import { render, staticRenderFns } from "./CashBank.vue?vue&type=template&id=36d3c497&"
import script from "./CashBank.vue?vue&type=script&lang=js&"
export * from "./CashBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports